import { Editor } from '@ckeditor/ckeditor5-core/src/editor/editor';
import { Skeleton } from 'antd';
import React, { FC, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { AIFillAppAPI } from 'api/ai-fill';
import { AiFillAppDestination } from 'api/ai-fill/types';
import { RichTextEditor } from 'components/atoms/rich-text-editor';
import { Caption01 } from 'components/styles';

const Footer = styled.div`
  ${Caption01};
  color: var(--gray-50);
`;
const Loader = styled.div``;
const Wrapper = styled.div`
  padding: var(--spacing-03);
  border: 1px solid var(--coolest-gray-20);
  background-color: var(--coolest-gray-10);
  border-radius: var(--border-radius-default);
  position: relative;
  .editor {
    width: 100%;
    --rte-background: transparent;
    --rte-readonly-content-padding: 0;
    --rte-max-height: unset;
    max-height: unset;
    .ck.ck-content {
      max-height: unset;
    }
  }
  ${Footer} {
    display: flex;
    justify-content: end;
  }
`;

interface Props {
  appId: string;
  sourceMeetingIds: number[];
  uniqueId: string;
  editor: Editor;
  destination: AiFillAppDestination;
}
export const AIFillResolveApp: FC<Props> = ({
  appId,
  uniqueId,
  sourceMeetingIds,
  editor,
  destination,
}) => {
  const [data, setData] = useState<string>('');
  const [initialDataLoading, setInitialDataLoadingState] = useState(true);

  useEffect(() => {
    setInitialDataLoadingState(true);
    const api = Number.isNaN(Number(appId))
      ? AIFillAppAPI.streamContentForDefaultAIFillApp
      : AIFillAppAPI.streamContentForCustomAIFillApp;

    api({
      appId,
      sources: sourceMeetingIds.map((sourceId) => ({
        sourceId,
        sourceType: 'MEETING',
      })),
      destination,
      onContentReceived: (content) => {
        setInitialDataLoadingState(false);
        setData(content);
      },
    }).then((content) => {
      setData(content);
      editor.execute('ai-fill-resolved', {
        appId,
        uniqueId,
        content,
      });
    });
  }, [appId, destination, editor, sourceMeetingIds, uniqueId]);

  return (
    <Wrapper>
      {initialDataLoading ? (
        <Loader>
          <Skeleton title paragraph={{ rows: 2 }} active />
        </Loader>
      ) : (
        <RichTextEditor className="editor" data={data} readonly />
      )}
      <Footer>
        <FormattedMessage id="ai_fill.generating_with_ai" />
      </Footer>
    </Wrapper>
  );
};
